import React, { FC, RefObject, MouseEvent as IMouseEvent } from 'react';
import { scale } from '@components/frame';
import { ColorFunction } from '@styles/colors/types';
import WebView from 'react-native-webview';
import { Popup } from '@components/machines/components/timeline';
import { MachineEventSearchItem } from '@interfaces/machines';
import { useManageBatchTimeLineTrack } from '@v2/pages/batch/details/modules/batch/hooks/useManageBatchTimeLineTrack';

export interface BatchTimeLineTrackProps {
  C: ColorFunction;
  height?: number;
  borderRadius?: number;
  roundOnlyBottom?: boolean;
  roundOnlyTop?: boolean;
  productionBatchId?: number | string;
  start: string | null;
  end?: string;
  triggerShowPopup?: (config: any, type: Popup) => void;
  triggerHidePopup?: (type: Popup) => void;
  timelineRef?: RefObject<HTMLDivElement>;
  setEvents?: (events: MachineEventSearchItem[]) => void;
  setEnd?: (endTime: string) => void;
  handleMouseMove?: (event: IMouseEvent<HTMLDivElement>) => void;
  actualTimeForLatestEvent?: number | null;
  withGaps?: boolean;
  events?: MachineEventSearchItem[];
  ncFileId?: string;
}

const BatchTimeLineTrack: FC<BatchTimeLineTrackProps> = (props) => {
  const {
    webView,
    handleMessage,
    generateHtml,
    radiusStyle,
    height,
  } = useManageBatchTimeLineTrack(props);

  return (
    <WebView
      onMessage={handleMessage}
      ref={webView}
      key={`${scale(1)}`}
      originWhitelist={['*']}
      source={{ html: generateHtml() }}
      scrollEnabled={false}
      opaque={false}
      style={[{ height, backgroundColor: 'transparent' }, radiusStyle]}
    />
  );
};

export default BatchTimeLineTrack;
